import { render, staticRenderFns } from "./DepartmentStudentIndex.vue?vue&type=template&id=087539e0"
import script from "./DepartmentStudentIndex.vue?vue&type=script&lang=js"
export * from "./DepartmentStudentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports